export default __webpack_public_path__ + "static/media/all-virtual-data-mobile (2).4affb76a.png";